<app-modal
  [title]="'CineCard' | trans:'cards/cinecard-actions-modal/header/title'"
  maxWidth="1200px"
  minWidth="30%"
  width="fit-content"
  [compact]="true"
>
  <ng-template>
    <div class="d-grid gap-12">
      <button
        class="button button--quick-action"
        (click)="fetchCardDetails()"
      >
        <i class="ri-bank-card-line"></i>
        {{ 'Kartendaten abrufen' | trans:'cards/cinecard-actions-modal/buttons/fetchCardDetails.Button' }}
      </button>
      <button
        class="button button--quick-action"
        (click)="loadCardBalance()"
      >
        <i class="ri-flashlight-line"></i>
        {{ 'Kartenguthaben aufladen' | trans:'cards/cinecard-actions-modal/buttons/loadCardBalance.Button' }}
      </button>
      <button
        class="button button--quick-action"
        [appWebCashPermissionControl]="permissionKeys.WebCxCashCardWithdraw"
        (click)="withdrawCardBalance()"
      >
        <i class="ri-coins-line"></i>
        {{ 'Kundenkarte auszahlen' | trans:'cards/cinecard-actions-modal/buttons/withdrawCardBalance.Button' }}
      </button>
      <button
        class="button button--quick-action"
        (click)="undoLastLoad()"
      >
        <i class="ri-arrow-go-back-line"></i>
        {{ 'Letzte Ladung rückgängig machen' | trans:'cards/cinecard-actions-modal/buttons/undoLastLoad.Button' }}
      </button>
      <button
        class="button button--quick-action"
        [appWebCashPermissionControl]="permissionKeys.WebCxCashCardCancel"
        (click)="cancelCustomerCard()"
      >
        <i class="ri-close-circle-line"></i>
        {{ 'Kundenkarte stornieren' | trans:'cards/cinecard-actions-modal/buttons/cancelCustomerCard.Button' }}
      </button>
      <button
        class="button button--quick-action"
        (click)="exchangeCardWithFee()"
      >
        <i class="ri-arrow-left-right-line"></i>
        {{ 'Kundenkarte mit Gebühren tauschen' | trans:'cards/cinecard-actions-modal/buttons/exchangeCardWithFee.Button' }}
      </button>
      <button
        class="button button--quick-action"
        [appWebCashPermissionControl]="permissionKeys.WebCxCashCardExchangeWithoutFee"
        (click)="exchangeCardWithoutFee()"
      >
        <i class="ri-arrow-left-right-line"></i>
        {{ 'Kundenkarte ohne Gebühren tauschen' | trans:'cards/cinecard-actions-modal/buttons/exchangeCardWithoutFee.Button' }}
      </button>
      <button
        class="button button--quick-action"
        [appWebCashPermissionControl]="permissionKeys.WebCxCashOnlineOrders"
        (click)="openOnlineOrders()"
      >
        <i class="ri-shopping-bag-line"></i>
        {{ 'Online-Kartenbestellungen' | trans:'cards/cinecard-actions-modal/buttons/onlineOrders.Button' }}
      </button>
    </div>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="close()"
      >
        {{ 'Cancel' | trans:'cards/cinecard-actions-modal/cancel.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>

<app-card-code-input-modal
  #cardCodeInputModalComponent
  (codeSubmitted)="onCodeSubmitted($event)"
  (voucherDetailsRequested)="onVoucherDetailsRequested($event)"
/>

<app-card-details-modal #cardDetailsModalComponent />

<app-card-amount-picker-modal #cardAmountPickerModalComponent />

<app-voucher-details-modal #voucherDetailsModalComponent></app-voucher-details-modal>

<app-online-orders-modal #onlineOrdersModalComponent />
